import axios from "@/axios";
import { Message } from "element-ui";
import { geetest4 } from '@/utils/geetest'
export const queryNewReviewList = data => getData(data, "brandSearch/queryNewReviewList", "post");  // 评审文书列表
export const queryReviewDetailInfo = (data, fn) => getData(data, "brand/queryReviewDetailInfo", "post", '', fn);  // 评审文书详情
export const queryLitigantList = data => getData(data, "brand/queryLitigantList", "post");  // 搜索智能补全
export const queryBrandReviewSummary = data => getData(data, "brand/queryBrandReviewSummary", "post");  // 获取列表树
export const queryBrandReviewList = (data, fn) => getData(data, "brandSearch/queryBrandReviewList", "post", '', fn);  // 商标评审文列表
export const brandReviewExport = data => getData(data, "brandSearch/brandReviewExport", "post");  // 导出商标评审文书
export const getExportList = data => getData(data, "brandSearch/getExportList", "post");  // 导出商标评审文书
export const deleteExportItemById = data => getData(data, "brandSearch/deleteExportItemById", "post");  // 删除商标评审文书

export const queryLawClause = data => getData(data, "common/queryLawClause", "post");  // 法律依据
export const queryLawContent = data => getData(data, "common/queryLawContent", "post");  // 根据法律条款查询法律内容

export const queryRelationCases = data => getData(data, "brand/queryRelationCases", "post");  // 关联案件信息

export const getUserExpireByproduct = data => getData(data, "thirdorder/getUserExpireByproduct", "post");  // 全球商标搜索专业版价格表
export const saveThirdOrder = data => getData(data, "thirdorder/saveThirdOrder", "post");  // 升级权益下单
export const queryThirdOrderInfo = data => getData(data, "thirdorder/queryThirdOrderInfo", "post");  // 升级权益获取收款结果
export const getPayEwm = data => getData(data, "pay/unitedPay/v1", "post");  // 升级权益获取收款码
export const saveCueData = data => getData(data, "common/saveCueData", "post");  // 升级权益提交申请

export const getUserPermList = data => getData(data, "brandSearch/brandPerm/getUserPermList", "post");  // 获取用户权限



export async function getData(data, url, methods, tips, fn) {
  let res = await axios({
    url,
    method: methods,
    data
  });
  
  if (res.data.code == 9091 &&res.data.subCode == 10002) {
    if (tips) {
      Message.success(`${tips}成功！`);
    }
    return res.data.data;
  } else if (res.data.code === 8888 && fn) {
    geetest4(fn, url.split('/')[1])
    return;
  } else if (res.data.subCode === 10088) {
    return 10088;
  } else if (res.data.subCode != 10002) {
    Message.error(res.data.subMessage);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/framework/API/common.js